import axios from "axios";

export default function EmployeedocumentWildcardsService(employeeId, templateId) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/employee/" + employeeId + "/create-document-template/" + templateId,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
